﻿window.incidenttest = function () {

    return {
        initialize: function () { },
    }
}